import React from 'react';
import { AlertTriangle, XCircle, RefreshCw } from 'lucide-react';

const SessionStatusBanner = ({ status, expiresAt, daysRemaining, onReconnect }) => {
  const isExpired = status === 'expired';
  const isExpiringSoon = status === 'expiring_soon';

  if (!isExpired && !isExpiringSoon) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  return (
    <div
      className={`px-4 py-3 flex items-center gap-3 ${
        isExpired
          ? 'bg-red-500/10 border-b border-red-500/30'
          : 'bg-amber-500/10 border-b border-amber-500/30'
      }`}
    >
      {isExpired ? (
        <XCircle className="w-5 h-5 text-red-500 flex-shrink-0" />
      ) : (
        <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0" />
      )}

      <div className="flex-1">
        <p className={`text-sm font-medium ${isExpired ? 'text-red-400' : 'text-amber-400'}`}>
          {isExpired
            ? 'Your Facebook session has expired'
            : `Your session expires in ${daysRemaining} day${daysRemaining !== 1 ? 's' : ''}`
          }
        </p>
        <p className={`text-xs ${isExpired ? 'text-red-400/70' : 'text-amber-400/70'}`}>
          {isExpired
            ? 'Reconnect to continue monitoring for leads.'
            : `Expires on ${formatDate(expiresAt)}. Reconnect to extend your session.`
          }
        </p>
      </div>

      <button
        onClick={onReconnect}
        className={`px-4 py-2 rounded-lg font-medium text-sm flex items-center gap-2 transition-colors ${
          isExpired
            ? 'bg-red-500 hover:bg-red-400 text-white'
            : 'bg-amber-500 hover:bg-amber-400 text-white'
        }`}
      >
        <RefreshCw className="w-4 h-4" />
        Reconnect
      </button>
    </div>
  );
};

export default SessionStatusBanner;
